<template>
    <div class="customer-unlink-accounts-btn">
        <v-tooltip left>
            <template #activator="{ on }">
                <v-btn
                    v-on="on"
                    v-bind="$attrs"
                    text
                    icon
                    @click="show(atomIds)"
                    class="drei_60-red-text"
                    :disabled="disabled"
                >
                    <v-icon v-bind="$attrs">mdi-link-variant-remove</v-icon>
                </v-btn>
            </template>
            <span>Verknüpfung entfernen</span>
        </v-tooltip>
        <v-dialog
            :value="showDialog"
            :key="selectedAtomIds[0]"
            max-width="500"
            persistent
        >
            <v-card>
                <v-card-title
                    class="headline"
                    primary-title
                >Verknüpfung entfernen</v-card-title>
                <v-card-text>
                    <p class="body-1 mb-2">
                        Soll die Verknüpfung des Kontos wirklich entfernt werden?
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="warning"
                        outlined
                        @click="abort"
                        :disabled="loading"
                    >Abbrechen</v-btn>
                    <v-btn
                        color="error"
                        outlined
                        :disabled="loading"
                        @click="remove"
                    >
                        Verknüpfung entfernen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {
    mapState,
    mapMutations,
    mapActions,
} from 'vuex';

export default {
    name: 'UnlinkAccountsBtn',
    props: ['ssoId', 'atomIds', 'disabled'],
    computed: {
        ...mapState('customerUnlinkAccount', [
            'loading',
            'removing',
            'showDialog',
            'selectedAtomIds',
        ]),
    },
    methods: {
        ...mapMutations('customerUnlinkAccount', [
            'hideDialog',
            'openDialog',
        ]),
        ...mapMutations('snackbar', ['success', 'error', 'info']),
        ...mapActions('customerUnlinkAccount', [
            'unlinkAccount',
        ]),
        show(atomIds) {
            this.openDialog(atomIds);
        },
        abort() {
            this.hideDialog();
            this.info('Das Entfernen der Verknüpfung wurde abgebrochen.');
        },
        remove() {
            this.unlinkAccount(this.ssoId)
                .then(() => {
                    this.success('Das Entfernen der Verknüpfung war erfolgreich.');
                })
                .catch(() => {
                    this.error('Das Entfernen der Verknüpfung ist fehlgeschlagen.');
                });
        },
    },
};

</script>
<style scoped lang="scss"></style>
